module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAABCBAMAAADAnRmrAAAAD1BMVEUAAAAzMzMzMzMzMzMzMzNw57/sAAAABHRSTlMAEJ/PUreMHgAAAHVJREFUOMvtysENgDAMQ1FjMQAjVNl/pnaDqBNQDjglcGKA+pLo6wGaxcO4Vj7FJlJhAcur2EC3XFgcTYgiDS5EkY4hxCAIxCAIxEkCcZJAfIgQHyLERG7ERG7ETADvxiMRYLRtryfyvO7+ChiN+G6VVVb5Uy6smDv6akLxuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/images/arrows/cursor-up-dark-2x.png
// module id = ../../../../../src/assets/images/arrows/cursor-up-dark-2x.png
// module chunks = styles